import UserDetailPage from "./UserDetailPage";
import AdminStateGroupDetailPage from "./AdminStateGroupDetailPage";
import ProviderDetailPage from "./ProviderDetailPage";

export default class ProviderUserPage extends UserDetailPage {
  static PageInfo = {
    
    parent: ProviderDetailPage,
    hidden:true,
    path:"/Admin/Providers/Detail/:id/User/:target",
    name: "menu.user",
    access: { 1: true },
    permission: { "CONFIGURATION_USERS_ACCESSING": true },
    icon: "user"
  }
}  